module.exports = __webpack_public_path__ + "media/gift-card/gift-card-wave-b43c2e2f.svg";